<script lang="ts" module>
    export const route = "/ms365-admin-consent-callback";
    export const sessionRequired = false;
</script>

<script lang="ts">
    import { Card, CardContent } from "../lib/components/ui/card";
    import CheckCircle from "@lucide/svelte/icons/circle-check";
    import XCircle from "@lucide/svelte/icons/circle-x";
    import { m } from "../lib/messages.svelte.js";
    import icon from "../assets/icon-192x192.png";
    import { useURL } from "../lib/url.svelte.js";
    import { z } from "@repo/utils";

    const url = useURL({
        tenant: z.string(),
        error: z.string(),
        error_description: z.string(),
    });
    let isSuccess = $derived(!!url.query.tenant && !url.query.error);
</script>

<div class="bg-background flex min-h-screen items-center justify-center p-4">
    <Card class="w-full max-w-md">
        <CardContent class="pt-12 text-center">
            <enhanced:img src={icon} alt="Turian Logo" class="mx-auto mb-8 h-20 w-20" />

            {#if isSuccess}
                <CheckCircle class="mx-auto mb-6 h-16 w-16 text-green-600" />
                <h1 class="mb-4 text-2xl font-semibold">{m["ms365AdminConsent.success"]()}</h1>
                <p class="text-muted-foreground mb-6">
                    {m["ms365AdminConsent.successDescription"]()}
                </p>
                <div class="rounded-lg bg-green-50 p-4 text-left dark:bg-green-900/20">
                    <p class="text-muted-foreground text-sm font-medium">{m["ms365AdminConsent.tenantId"]()}</p>
                    <p class="mt-1 font-mono text-sm wrap-break-word">{url.query.tenant}</p>
                </div>
            {:else}
                <XCircle class="text-destructive mx-auto mb-6 h-16 w-16" />
                <h1 class="mb-4 text-2xl font-semibold">{m["ms365AdminConsent.failed"]()}</h1>
                <p class="text-muted-foreground mb-6">
                    {m["ms365AdminConsent.failedDescription"]()}
                </p>
                <div class="border-destructive/20 bg-destructive/10 rounded-lg border p-4 text-left">
                    <p class="text-destructive text-sm font-medium"
                        >{m["ms365AdminConsent.error"]()}: {url.query.error || m["ms365AdminConsent.unknownError"]()}</p
                    >
                    {#if url.query.error_description}
                        <p class="text-destructive/80 mt-2 text-sm">{url.query.error_description}</p>
                    {/if}
                </div>
            {/if}
        </CardContent>
    </Card>
</div>
